import { useEffect } from 'react';
import { trackScreenView } from './AnalyticsHelpers';
import { ProductType, ScreenName } from './eventMapper';

export function useScreenView(screen: ScreenName, productType?: ProductType) {
  useEffect(() => {
    trackScreenView(screen, productType);
  }, []);
}
